// Anulowanie przetwarzania wiadomości

import { orionAxios } from '../orionApi';

/**
 * Anuluje bieżące przetwarzanie wiadomości przez AI
 * @param threadId - UUID wątku
 */
export const cancelProcessing = async (threadId: string): Promise<void> => {
  await orionAxios.post(`/api/aiassistant/cancel-processing/${threadId}`, {});
};

